import httpClient from '@/http-client'
import config from '../config'

export const get = () => {
  return httpClient
    .get(`${config.apiPrefix}/payment-resources`)
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))
}

export default { get }
